import clsx from 'clsx'
import { TabPanel, TabView } from 'primereact/tabview'
import { useState, useEffect } from 'react'
import * as axios from 'axios'
import ProjectDetailsOrderLineList from '../project-details-order-line-list/ProjectDetailsOrderLineList'
import ProjectDetails from '../project-details/ProjectDetails'
import ProjectTaskList from '../project-task-list/ProjectTaskList'
import classes from './ProjectListDetailTab.module.scss'
import PmrE2EProjectModel from '../shared/interfaces/pmr-e2e-project-model'
import { ComponentWithIndices } from '../../../hooks/usePmrShiftSelect'
import ProjectService from '../../../services/ProjectService'
import {
  selectRefreshProjectId,
  updateRefreshProjectId,
} from '../../../features/projectManagement/projectManagementSlice'
import { useDispatch, useSelector } from 'react-redux'
import AssociatedFLEXProjects from '../associated-flex-projects/AssociatedFLEXProjects'

interface ProjectListDetailTabProps extends ComponentWithIndices {
  projectId: string
  project: PmrE2EProjectModel
  overrideActiveTabIndex: number | null
  afterTabChange?: () => void
}
interface ProjectLineFlexCount {
  flexProjectCount: number
  orderLineCount: number
}

const ProjectListDetailTab = (props: ProjectListDetailTabProps) => {
  const dispatch = useDispatch()
  const projectIdToRefresh = useSelector(selectRefreshProjectId)
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const [flexOrderlineCount, setFlexOrderlineCount] = useState<ProjectLineFlexCount>()

  const getFlexOrderLineCount = async (projectIdTorefresh: string) => {
    try {
      const response = await ProjectService.getFlexOrderLineCount(projectIdTorefresh)

      if (response.isSuccess) setFlexOrderlineCount(response.data)
    } catch (e) {
      if ((axios as any).isCancel(e)) {
        console.warn('Get Flex and Order line Count Cancelled.')
        return
      }
    }
  }

  useEffect(() => {
    if (props.overrideActiveTabIndex === null) return

    setActiveTabIndex(props.overrideActiveTabIndex)
    if (props.afterTabChange) props.afterTabChange()
  }, [props.overrideActiveTabIndex])

  useEffect(() => {
    if (activeTabIndex === 0) getFlexOrderLineCount(props.projectId)
  }, [activeTabIndex])

  useEffect(() => {
    if (projectIdToRefresh !== '') {
      getFlexOrderLineCount(projectIdToRefresh)
      dispatch(updateRefreshProjectId(''))
    }
  }, [projectIdToRefresh])

  return (
    <>
      <div className={`${classes['tab-container']}`}>
        <TabView activeIndex={activeTabIndex} onTabChange={e => setActiveTabIndex(e.index)}>
          <TabPanel header="Table" />
          <TabPanel header="Project Details" />
          <TabPanel header="Order Line Details" />
          <TabPanel header="Associated FLEX Projects" />
        </TabView>

        <div className={classes['tab-panel']}>
          <div className={clsx(activeTabIndex !== 0 && 'd-none')}>
            {flexOrderlineCount && (
              <div className={`${classes['orderline-counter']}`}>
                <b>FLEX Project:</b> {flexOrderlineCount?.flexProjectCount} |<b>Order Lines:</b>{' '}
                {flexOrderlineCount?.orderLineCount}
              </div>
            )}
            <ProjectTaskList
              projectName={props.project.name}
              projectStatus={props.project.status}
              projectId={props.projectId}
              isActive={activeTabIndex === 0}
              depthIndices={props.depthIndices}
            ></ProjectTaskList>
          </div>

          {activeTabIndex === 1 && <ProjectDetails projectId={props.projectId}></ProjectDetails>}

          {activeTabIndex === 2 && (
            <ProjectDetailsOrderLineList
              project={props.project}
              projectId={props.projectId}
            ></ProjectDetailsOrderLineList>
          )}

          {activeTabIndex === 3 && (
            <AssociatedFLEXProjects projectId={props.projectId}></AssociatedFLEXProjects>
          )}
        </div>
      </div>
    </>
  )
}
export default ProjectListDetailTab
